import React, { useContext, useEffect, useState } from "react";

import { getAttributesByGroup } from "../../attributes/lib/attribute-data";
import { AttributesContext } from "../../../contexts/attributes";

import AddBullet from "./components/add-bullet";
import Bullet from "./components/bullet";
import { checkMultiMatch } from "../typeahead/lib/check-match";
import { valueByTypeToArray } from "./lib/helpers";

const BULLET_COUNT = 7;
var afterLoad = false;

const FeatureBullets = ({ defaultValue, name, readOnly, updateOnChange }) => {
    const attributes = useContext(AttributesContext) || {};
    const [values, setValues] = useState(defaultValue || []);
    const [sourceAttributes, setSourceAttributes] = useState([]);
    const [options, setOptions] = useState([]);

    useEffect(() => {
        async function fetchData() {
            const group = await getAttributesByGroup("FeatureBulletSource");

            if (!group) {
                return;
            }

            setSourceAttributes(group);
            updateOptions(group);
            afterLoad = true;
        }

        fetchData();
    }, []);

    useEffect(() => {
        if (afterLoad) {
            updateOptions(sourceAttributes);
        }
    }, [sourceAttributes, attributes.data]);

    useEffect(() => {
        if (!checkMultiMatch(defaultValue || [], values)) {
            updateOnChange(name, [...values]);
        }
    }, [values]);

    useEffect(() => {
        if (!checkMultiMatch(defaultValue || [], values)) {
            setValues(defaultValue);
        }
    }, [defaultValue]);

    const updateOptions = (group) => {
        const optionValues = group.reduce((arr, a) => {
            if (attributes.data.hasOwnProperty(a.uuid)) {
                const useValues = valueByTypeToArray(attributes.data[a.uuid], a.componentType, a.name);

                if (useValues && useValues.length > 0) {
                    return [...arr, ...useValues];
                }
            }

            return arr;
        }, []);

        setOptions(optionValues);
    };

    const addValue = (n, v) => {
        setValues([...values, v]);
    };

    const updateValue = (i, v) => {
        const newValues = [...values];
        newValues[i] = v;
        setValues(newValues);
    };

    const removeValue = (index) => {
        const newValues = [...values];
        newValues.splice(index, 1);
        setValues(newValues);
    };

    const bullets =
        values && values.length > 0
            ? values.map((v, i) => {
                  return (
                      <Bullet
                          key={`featureBullet_${i}`}
                          id={`featureBullet_${i}`}
                          index={i}
                          value={v || ""}
                          label={`Feature Bullet ${i + 1}`}
                          options={options}
                          add={addValue}
                          remove={() => {
                              removeValue(i);
                          }}
                          readOnly={readOnly}
                          update={updateValue}
                      />
                  );
              })
            : null;

    const filteredOptions = options.filter((o) => !values.includes(o.value));

    return (
        <div className="feature-bullets product-compare">
            {bullets}
            {!readOnly && (!values || values.length < BULLET_COUNT) && <AddBullet options={filteredOptions} definitions={sourceAttributes} add={addValue} />}
        </div>
    );
};

export default FeatureBullets;
